<template>
    <div>
        <!-- 🔼 Header -->
        <div class="slide mb-5" style="margin-top: 74px !important;">
            <div class="bg-img">
                <div class="slide-content">
                    <div>
                        <h2 class="slide-header">{{ 'Downgrade' }}</h2>
                    </div>
                    <div>
                        <h5 class="slide-h5">{{ $t('message.home') }}</h5>
                        <b-icon :icon="isRTL ? 'chevron-double-left' : 'chevron-double-right'" class="icon-slider" />
                        <h5 class="slide-h5">{{ 'Downgrade' }}</h5>
                    </div>
                </div>
            </div>
        </div>

        <div class="container mt-3 mb-5">
            <b-form-group label="Select Store to show Inventories">
                <v-select v-model="store_id" :options="stores" :reduce="store => store.id" @input="handleStoreChange"
                label="name" class="form-control" style="border: none !important; padding: 0px !important;"
                placeholder="Select store" required />
            </b-form-group>
            <div v-if="this.store_id" class="d-flex justify-content-between align-items-center">
                <h4 class="item-details-header mt-4 mb-4">Downgrade List</h4>
                <!-- <b-button size="sm" class="btn-success store-action-btn" @click="showScrapModal = true">
                    Create Downgrade
                </b-button> -->
            </div>

            <!-- 🔍 Filter input -->
            <!-- <b-form-input
        v-model="filterText"
        placeholder="Search inventory by description..."
        class="mb-3"
      ></b-form-input> -->

            <!-- 🧾 Cards -->
            <div class="">


                <b-row>
                    <b-col v-for="(invoice, index) in Downgrade" :key="invoice.id" cols="12" md="6" lg="4" class="mb-4">
                        <div class="invoice-card" @click="goToInventoryDetails(invoice)" style="cursor: pointer;">
                            <div class="invoice-header">
                                <h5>
                                    <b-icon icon="file-earmark-text" variant="primary" class="mr-2" />
                                    {{ invoice.created_date }}
                                </h5>

                                <b-badge v-if="invoice.type !== '1'"
                                    :variant="getInventoryStatusVariant(invoice.status)">
                                    {{ getInventoryStatusText(invoice.status) }}
                                </b-badge>


                            </div>
                            
                            <div class="invoice-body">
                                <!-- <p>
                                <b-icon icon="person-fill" class="mr-2" />
                                <strong>Supplier:</strong> {{ invoice.supplier_name }}
                            </p> -->
                                <p>
                                    <b-icon icon="gear-fill" class="mr-2 text-info" />
                                    <strong>Created By :</strong>
                                    {{ 'Store'}}
                                </p>
                                <p>
                                    <b-icon icon="calendar-event-fill" class="mr-2 text-success" />
                                    <strong>Due Date :</strong>
                                    {{ invoice.created_date }}
                                </p>


                                <!-- <div class="mb-2 text-primary font-weight-bold"> -->


                            </div>
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <b-button disabled size="sm" variant="primary" style="border-radius:10px"
                                        @click.stop="openAddModal(invoice)">
                                        <b-icon icon="plus" class="mr-1" />
                                        Add Items
                                    </b-button>
                                </div>

                                <div class="invoice-footer">
                                    <small class="text-muted">
                                        <b-icon icon="hash" class="mr-1" />
                                        Return ID: {{ invoice.id }}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>

            <!-- 📄 Pagination -->
            <b-pagination v-if="totalProducts > perPage" v-model="currentPage" :total-rows="totalProducts"
                :per-page="perPage" align="center" class="mt-3" />

        </div>

        <!-- 🔽 Modal -->
        <!-- 🔽 Modal -->
        <b-modal v-model="showScrapModal" size="lg" title="Create Return" scrollable>
            <b-form>
                <!-- سبب أو وصف (اختياري) -->
                <b-form-group label="Notes (optional)">
                    <b-form-textarea v-model="scrapForm.notes" rows="3" placeholder="Write any notes here…" />
                </b-form-group>
            </b-form>

            <!-- ▸ أزرار المودال -->
            <template #modal-footer>
                <b-button variant="secondary" @click="showScrapModal = false">
                    Cancel
                </b-button>
                <b-button variant="primary" @click="submitScrap">
                    Save
                </b-button>
            </template>
        </b-modal>

        <b-modal size="lg" v-model="addModalVisible" title="Add Items to Downgrade" hide-footer>
            <!-- v-select بخاصية البحث -->
            <v-select :filterable="false" :options="itemsOptions" :reduce="i => i.id" label="name"
                v-model="itemSearchKey" 
                placeholder="Search item by name"
                @search="debouncedSearch"
                @input="addItemToList"
                >
                <template #no-options>
                    <span v-if="itemSearchKey">No results…</span>
                    <span v-else>Type to search…</span>
                </template>
            </v-select>

            <!-- جدول الأصناف المختارة -->
            <b-table :items="selectedItems" :fields="['name', 'quantity', 'remove']" responsive small class="mt-3">
                

                <template #cell(quantity)="row">
                    <b-form-input type="number" min="1" v-model="row.item.quantity" size="sm" />
                </template>

                <template #cell(remove)="row">
                    <b-button size="sm" variant="danger" @click="removeItem(row.index)">
                        ×
                    </b-button>
                </template>
            </b-table>

            <!-- أزرار -->
            <div class="text-center mt-3">
                <b-button variant="success" @click="submitScrapItems">
                    <b-icon icon="check-circle" class="mr-1" />
                    Save
                </b-button>
                <b-button variant="secondary" class="ml-2" @click="addModalVisible = false">
                    Close
                </b-button>
            </div>
        </b-modal>


    </div>
</template>

<script>
import axiosInstance from '../axios-config';
import { mapGetters } from 'vuex';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import debounce from 'lodash/debounce';


export default {
    components: {
        'v-select': vSelect,
    },
    data() {
        return {
            showModal: false,
            Downgrade: [],
            totalProducts: 0,
            form: {
                due_date: '',
                description: '',
                type: null,
                quantity_visable: null,
            },
            filterText: '',
            currentPage: 1,
            perPage: 6,
            now: new Date(), // ⏳ الوقت الحالي المتجدد
            intervalId: null,

            assignModalVisible: false,
            selectedInventoryId: null,

            addModalVisible: false,
            downgradeId: null,              // يُملأ عند الضغط على الزر
            itemSearchKey: '',
            searchItemsLoading: false,
            itemsOptions: [],           // نتائج البحث للـ v‑select
            selectedItems: [] ,          // [{ item_id, type, quantity }]
            store_id: null,
            stores: [],
            showScrapModal: false,
            scrapForm: {
                notes: ''
            },




        };
    },
    computed: {
        ...mapGetters(['getUser']),
        user() {
            return this.getUser;
        },
        isRTL() {
            return this.$i18n.locale === 'ar';
        },
        filteredAdmins() {
            const selectedIds = [
                this.assignForm.technical,
                this.assignForm.company,
            ].filter(Boolean); // لمنع التكرار في الاختيارات الأخرى

            return this.admins.filter(admin => !selectedIds.includes(admin.value));
        },
        // 🔍 Filter
        filteredInventories() {
            if (!this.filterText) return this.Downgrade;
            return this.Downgrade.filter(item =>
                item.description?.toLowerCase().includes(this.filterText.toLowerCase())
            );
        },
        // 📄 Pagination
        paginatedItems() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.filteredInventories.slice(start, end);
        },
    },
    watch: {
        filterText() {
            this.currentPage = 1;
        },
        currentPage() {
            this.fetchDowngrade(); // تحميل الصفحة الجديدة
        },
    },

    mounted() {
        // this.fetchDowngrade();
        this.fetchStores();
        // ⏱️ تحديث الوقت كل ثانية
        this.intervalId = setInterval(() => {
            this.now = new Date();
        }, 1000);
    },
    beforeDestroy() {
        clearInterval(this.intervalId);
    },
    methods: {
        handleStoreChange() {
            if (this.store_id) {
                this.fetchDowngrade();
            }
        },
        async fetchStores() {
      try {
        const formData = new FormData();
        formData.append("company_id", this.user.company_id); // لو موجود في اليوزر

        const res = await axiosInstance.post("store/select_stores.php", formData);

        if (res.data.status === "true") {
          this.stores = res.data.output;
        }
      } catch (err) {
        console.error("Error fetching stores", err);
      }
    },
    async submitScrap() {
            //   if (!this.scrapForm.store_id || this.scrapForm.type === null) {
            //     this.$izitoast.warning({
            //       title: 'Warning',
            //       message: 'Please select both store and scrap type.',
            //       position: 'bottomLeft'
            //     });
            //     return;
            //   }

            const formData = new FormData();
            formData.append('user_id', this.user.id);
            formData.append('store_id', this.store_id);

            try {
                const res = await axiosInstance.post('store/insert_downgrade.php', formData);

                if (res.data.status === 'true') {
                    this.$izitoast.success({
                        title: 'Success',
                        message: 'downgrade created successfully.',
                        position: 'bottomLeft'
                    });
                    this.showScrapModal = false;
                    // (اختياري) إعادة تحميل بيانات الـ scrap أو المخزن
                } else {
                    throw new Error(res.data.message || 'Unknown error');
                }
            } catch (err) {
                console.error('Scrap error:', err);
                this.$izitoast.error({
                    title: 'Error',
                    message: 'Failed to create downgrade.',
                    position: 'bottomLeft'
                });
            }
        },
        async fetchDowngrade() {
            try {
                const formData = new FormData();
                formData.append('store_id', this.store_id);
                formData.append('page_size', this.perPage);
                formData.append('page', this.currentPage);

                const response = await axiosInstance.post('store/select_downgrade.php', formData);
                if (response.data.status === 'true') {
                    this.Downgrade = response.data.output;
                    this.totalProducts = response.data.pagination?.total_products; // 🆕
                }
            } catch (err) {
                console.error('Error fetching Downgrade:', err);
                this.$izitoast.error({
                    title: "خطأ",
                    message: 'Error occurred.',
                    position: "bottomLeft",
                });
            }
        },

        async searchItems(query) {
            if (!query) return;

            this.searchItemsLoading = true;
            try {
                const fd = new FormData();
                fd.append('company_id', this.user.company_id);
                fd.append('search_key', query);

                const res = await axiosInstance.post('store/search_items.php', fd);

                if (res.data.status === 'true') {
                    // صيّغ النتيجة بالشكل المناسب للـ v‑select
                    this.itemsOptions = res.data.output.map(item => ({
                        id: item.id,
                        name: `${item.desc_ar}`
                    }));
                }
            } catch (e) {
                console.error('search_items error', e);
            } finally {
                this.searchItemsLoading = false;
            }
        },

        /* Debounce حتى لا نرهق الخادم */
        debouncedSearch: debounce(function (q) {
            this.searchItems(q);
        }, 400),

        /* إضافة الصنف المختار مع قيم افتراضية */
        addItemToList(itemId) {
            const chosen = this.itemsOptions.find(o => o.id === itemId);
            if (!chosen) return;

            // امنع التكرار
            if (this.selectedItems.some(s => s.item_id === itemId)) return;

            this.selectedItems.push({
                item_id: itemId,
                name: chosen.name,
                quantity: 1    // 1 افتراضيًا
            });

            // إعادة تعيين حقل البحث
            this.itemSearchKey = '';
        },

        removeItem(idx) {
            this.selectedItems.splice(idx, 1);
        },


        async submitScrapItems() {
            if (!this.selectedItems.length) {
                this.$izitoast.warning({ title: 'Warning', message: 'No items selected', position: 'bottomLeft' });
                return;
            }

            try {
                const res = await axiosInstance.post(
                    `store/insert_downgrade_items.php?downgrade_id=${this.downgradeId}`,
                    this.selectedItems,
                    { headers: { 'Content-Type': 'application/json' } }
                );

                if (res.data.status === 'true') {
                    this.$izitoast.success({ title: 'Success', message: 'Items added successfully', position: 'bottomLeft' });
                    this.addModalVisible = false;
                    // بعد نجاح الإرسال
                    this.$set(this.Downgrade.find(s => s.id == this.downgradeId), 'status', 1);
                    await this.updateScrapStatus(this.downgradeId, 1); // ⬅️ بعد الإضافة

                    // إعادة تحميل القائمة إن أحببت
                    this.fetchDowngrade();
                } else {
                    throw new Error(res.data.message);
                }
            } catch (e) {
                console.error(e);
                this.$izitoast.error({ title: 'Error', message: 'Failed to add items', position: 'bottomLeft' });
            }
        },

        async updateScrapStatus(downgradeId, status) {
  const formData = new FormData();
  formData.append('downgrade_id', downgradeId);
  formData.append('status', status);
    formData.append('comments', this.comments);


  try {
    const res = await axiosInstance.post('store/update_downgrade_status.php', formData);
    if (res.data.status === 'true') {
      this.$izitoast.success({
        title: 'Success',
        message: 'Downgrade status updated successfully',
        position: 'bottomLeft'
      });

      // 🟡 تحديث محلي للحالة في واجهة المستخدم (اختياري لكن مفيد)
      const updatedScrap = this.Downgrade.find(s => s.id == downgradeId);
      if (updatedScrap) updatedScrap.status = status;
    } else {
      this.$izitoast.error({
        title: 'Error',
        message: res.data.message || 'Failed to update status',
        position: 'bottomLeft'
      });
    }
  } catch (err) {
    console.error('Error updating scrap status:', err);
    this.$izitoast.error({
      title: 'Error',
      message: 'Request failed while updating status.',
      position: 'bottomLeft'
    });
  }
},

        openAddModal(scrap) {
            this.downgradeId = scrap.id;
            this.selectedItems = [];
            this.itemSearchKey = '';
            this.itemsOptions = [];
            this.addModalVisible = true;
        },






       
        goToInventoryDetails(scrap) {
            this.$router.push({
                name: 'downgradeDetails',
                params: { downgrade_id: scrap.id },  // لو لسه عاوز تحطه في الرابط
            });
        },

        /* داخل methods أو ملف helpers */
        getInventoryStatusText(status) {
            const map = {
                0: 'New',
                1: 'Waiting Admin',
                2: 'Cancelled by Admin',
                3: 'Waiting Finance',
                4: 'Cancelled by Finance',
                5: 'Waiting Company',
                6: 'Cancelled by Company',
                7: 'Requester Closed',
                8: 'Completed'
            };
            return map[status] || 'Unknown';
        },
        getInventoryStatusVariant(status) {
            const map = {
                0: 'warning',   // New
                1: 'info',      // Waiting Admin
                2: 'danger',    // Cancel Admin
                3: 'info',      // Waiting Finance
                4: 'danger',    // Cancel Finance
                5: 'info',      // Waiting Company
                6: 'danger',    // Cancel Company
                7: 'secondary', // Requester Close
                8: 'success'    // Completed
            };
            return map[status] || 'secondary';
        }






    },
};
</script>

<style scoped>
.item-history {
    border: 1px solid #ddd;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 90px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}

.item-details-header {
    font-size: 22px;
    font-weight: 600;
    color: #2274BD;
}

#add-employee-modal___BV_modal_content_ .form-control:disabled,
#employee-modal___BV_modal_content_ .form-control:disabled,
#employee-modal___BV_modal_content_ .form-control[readonly],
#add-employee-modal___BV_modal_content_ .form-control[readonly],
#employee-modal___BV_modal_content_ .form-control,
.form-control,
.form-control {
    background: transparent;
    border-width: 0px;
    border-bottom: 2px solid #D1E4FF;
    color: #7F98BB;
    font-family: 'Somar-Medium';
    font-size: 20px;

}

.form-control:disabled,
.form-control[readonly] {
    background-color: transparent;
    opacity: 1;
}

.form-control:focus {
    box-shadow: none !important;
}

.file-input {
    display: none;
}

/* modal */

.modal-dialog .modal-content {
    border-radius: 10px !important;
    overflow: hidden !important;
    /* لضمان عدم ظهور الحواف خارج الحدود */
}

/* تحسين شكل التمرير */
.modal-dialog .modal-body {
    max-height: 60vh;
    /* لتقييد ارتفاع التمرير */
    overflow-y: auto;
    padding: 1rem;
    scrollbar-width: thin !important;
    /* للمتصفحات الحديثة */
    scrollbar-color: #888 #f0f0f0 !important;
    /* لون شريط التمرير */
}

/* تحسين شكل التمرير للـ webkit (Chrome, Edge, Safari) */
.modal-dialog .modal-body::-webkit-scrollbar {
    width: 8px !important;
    /* عرض شريط التمرير */
}

.modal-dialog .modal-body::-webkit-scrollbar-track {
    background: #f0f0f0 !important;
    /* لون الخلفية */
}

.modal-dialog .modal-body::-webkit-scrollbar-thumb {
    background-color: #888 !important;
    /* لون التمرير */
    border-radius: 4px !important;
}

/* جعل الأزرار في الـ footer دائرية */
.footer-btn {
    border-radius: 10px;
}

/* تحسين المسافات بين الأزرار */
.modal-footer .footer-btn {
    margin: 0 5px;
}

.invoice-card {
    background: linear-gradient(135deg, #f9fcff, #eaf4ff);
    border: none;
    border-left: 6px solid #0d6efd;
    border-radius: 18px;
    padding: 25px;
    box-shadow: 0 6px 20px rgba(13, 110, 253, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    height: 100%;
}

.invoice-card:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 30px rgba(13, 110, 253, 0.15);
}

.invoice-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.invoice-header h5 {
    font-size: 1.3rem;
    font-weight: 700;
    color: #0d6efd;
    display: flex;
    align-items: center;
}

.invoice-body {
    font-size: 1.05rem;
    color: #333;
    margin-bottom: 15px;
}

.invoice-body p {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
}

.invoice-body b-icon {
    font-size: 1.2rem;
    margin-right: 10px;
    color: #0d6efd;
}

.invoice-footer {
    text-align: right;
    font-size: 0.95rem;
    color: #666;
}

.custom-modal {
    border-radius: 10px !important;
    padding: 15px;
    /* background: #f8f9fa; */
}
</style>
